// Quill's `setContents` expects an array (delta) with each object inside of it
// containing `insert`. Sometimes quill editor screws up and records jsonb without it
// (e.g. a trailing `{attributes: {...}}`), which makes Quill crash
//
// This sanitizer removes those potential bad objects from the array

const sanitizeDelta = (delta) => {
  if (!Array.isArray(delta)) return delta;

  return delta.filter((record) => {
    if (!record || typeof record !== 'object') return false;

    // if no 'insert', remove it
    const { insert } = record;
    return typeof insert === 'string' || (insert !== null && typeof insert === 'object');
  });
};

export default sanitizeDelta;
